import { DecorateIndex, RefreshSchedules } from "event-definitions"

let treeIndex = { retrieve: () => null }
let treeIndexClient

export function setTreeIndex(index, client) {
    index = DecorateIndex.call({ index })
    treeIndex = index
    treeIndexClient = client
    RefreshSchedules.raiseOnceDelay(100)
}

export function getTreeIndex() {
    return treeIndex
}

export function isTreeIndexForClient(client) {
    return !!client && treeIndexClient === client
}
